import React from 'react';

import { withStyles } from '@mui/styles';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

const styles = {
  tblTitle: {
    padding: '6px 16px',
    fontWeight: 'bold',
    fontSize: '12px',
  },
  tblCell: {
    padding: '1px 0px 1px 16px',
    fontSize: '12px',
  },
  clm1: {
    width: '10px',
  },
  clm2: {
    width: '300px',
  },
  clm3: {
    width: '400px',
  },
};

export default withStyles(styles)((
  {
    data,
    nodes,
    classes,
  }) => {

  let rowIndex = 0;

  return (
    <Table
      style={{
        background: '#fff'
      }}
      className={classes.mb20}
    >
      <TableHead>
        <TableRow>
          <TableCell className={`${classes.tblTitle} ${classes.clm1}`}>#</TableCell>
          <TableCell className={`${classes.tblTitle} ${classes.clm2}`}>Inference id</TableCell>
          <TableCell className={`${classes.tblTitle} ${classes.clm3}`}>Subscriber</TableCell>
          <TableCell className={classes.tblTitle}>Node</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.keys(data).map((inferenceId, inferenceIdIdx) => {
          const inferencesArray = data[inferenceId];

          return (
            <React.Fragment key={inferenceIdIdx}>
              {Object.values(inferencesArray).map((inferenceInfo, infInfoIdx) => {
                rowIndex++;

                return (
                  <TableRow key={infInfoIdx}>
                    <TableCell className={classes.tblCell}>
                      {rowIndex}
                    </TableCell>

                    <TableCell className={classes.tblCell}>
                      {inferenceId}
                    </TableCell>

                    <TableCell className={classes.tblCell}>
                      <a href={"/node/" + inferenceInfo.cid} rel="noreferrer" target="_blank">{inferenceInfo.cid}</a>
                      {' '}|{' '}
                      {nodes[inferenceInfo.cid] ? nodes[inferenceInfo.cid].title : ''}
                    </TableCell>

                    <TableCell className={classes.tblCell}>
                      <a href={"/node/" + inferenceInfo.id} rel="noreferrer" target="_blank">{inferenceInfo.id}</a>
                      {' '}|{' '}
                      {nodes[inferenceInfo.id] ? nodes[inferenceInfo.id].title : ''}
                    </TableCell>
                  </TableRow>
                );
              })}
            </React.Fragment>
          );
        })}
      </TableBody>
    </Table>
  );
});
